import { z } from 'zod';
import { ProductionTableColumns } from '@/routes/_stacktrace/production/-table/type';
import { type ProductionStatus, ProductionStatus as PS, type ProductionStatusFilter } from './-query/type';
const productionStatusValues = Object.values(PS) as [ProductionStatus, ...ProductionStatus[]];
export const ProductionStatusFilterSchema = z.enum(['ALL', ...productionStatusValues]);

/**
 * プロダクション一覧のステータスタブ並び順。
 * ワークフロー順 → 全件:
 *   PLANNED → IN_PROGRESS → APPROVED → RELEASED → ALL
 */
export const STATUS_TABS = [PS.PLANNED, PS.IN_PROGRESS, PS.APPROVED, PS.RELEASED, 'ALL'] as const satisfies readonly ProductionStatusFilter[];
export function buildProductionTabChangeSearch(tab: string) {
  const result = ProductionStatusFilterSchema.safeParse(tab);
  return {
    status: result.success ? result.data : PS.IN_PROGRESS,
    pageIndex: 0,
    sortColumn: ProductionTableColumns.PLANNED_RELEASE_DATE,
    orderDirection: 'desc' as const
  };
}